import { useMemo } from 'react';
import * as R from 'ramda';

var hasUniqUnlabelledOption = R.allPass([R.pipe(R.length, R.equals(1)), R.pipe(R.head, R.prop('label'), R.anyPass([R.isNil, R.isEmpty]))]);

var useFocusOptions = function useFocusOptions() {
  var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var options = useMemo(function () {
    return R.when(hasUniqUnlabelledOption, R.set(R.lensPath([0, 'label']), R.prop('uniqFocusOption', labels)))(focus.options);
  }, [labels, focus.options]);

  var indexedOptions = useMemo(function () {
    if (!options) return {};
    return R.indexBy(R.prop('value'), options);
  }, [options]);

  return [options, indexedOptions];
};

export default useFocusOptions;